module.exports = __webpack_public_path__ + "img/m-icon-5.42c7328b.png";